<template>
  <div>
    <div v-show="false"> {{getSearchResultsCounter}} </div>
    <div v-if="this.getSearchResults.length === 0">
      <v-layout row class="mt-4 align-center justify-center row fill-height">
        <v-card :class="ui.bkgdColor" :max-width="ui.cardMinWidth">
          <v-card-title primary-title>
            <v-layout row>
              <v-icon left :class="ui.chipColor"> warning </v-icon>
              <a :class="ui.textTitle">
                Register
              </a>
            </v-layout>
          </v-card-title>
          <v-layout row class="ml-4 mr-4  mb-4 mt-4">
            <a :class="ui.textSubheading">
              Please contact Admin for info.
            </a>
          </v-layout>
        </v-card>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row>
        <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
          <RegisterListHeading/>
          <v-data-table
          :headers="headers"
          :items="getSearchResults"
          class="elevation-1"
          :total-items=this.maxRows
          :hide-actions=this.hideActions
          >
           <template slot="items" slot-scope="props">
             <td class="text-xs-left">
               <!-- <v-btn flat>
                 <v-icon left :color="ui.btnColor">
                   text_snippet
                 </v-icon>
                 {{ defineTableContent(props.item).item0}}
               </v-btn> -->
               <!-- ID  -->
               {{ defineTableContent(props.item).item0}}
             </td>
             <td class="text-xs-left">
               <!-- TAG or Type -->
               {{ defineTableContent(props.item).item1 }}
             </td>
             <!-- TITLE -->
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item2 }}
            </td>
            <!-- TYPE -->
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item3 }}
             </td>
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item4 }}
             </td>
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item5 }}
             </td>
             <td class="text-xs-right">
               <!-- {{this.getRegisterInfo.tag}} -->
               <v-layout row>
                 <v-spacer/>
                 <v-btn :text-color="ui.textColor" flat
                 v-if="(props.item.basic.tag === 'W1' || props.item.basic.tag === 'W2') &&
                 props.item.char.comp !== ''">
                   <v-icon left :color="ui.btnColor"> assured_workload </v-icon>
                     <div :class="ui.textSubheadingBold">
                       {{props.item.char.comp}}
                     </div>
                 </v-btn>
                 <RegisterSelect :listIndex="props.index" v-if="enableRegisterSelect"/>
                 <v-btn icon v-if="enableItemReachIcon">
                   <v-icon :color="ui.btnColor" v-if="props.item.link.ft !== ''">
                     place
                   </v-icon>
                   <v-icon :color="ui.btnColor" v-else>
                     account_balance
                   </v-icon>
                 </v-btn>
                 <v-btn icon v-if="enableOpsComplete">
                   <v-icon :color="ui.btnColorWarning"
                   v-if="props.item.char.stat === true && props.item.basic.ver !== 'A'">
                     done
                   </v-icon>
                 </v-btn>
                 <v-btn icon v-if="enableItemAllocationIcon">
                   <v-icon :color="ui.btnColor" v-if="props.item.link.fdid !== undefined && props.item.link.fdid !== ''">
                     place
                   </v-icon>
                   <v-icon :color="ui.btnColor" v-else>
                     account_balance
                   </v-icon>
                 </v-btn>
                 <v-btn icon v-if="props.item.basic.tag === 'M5'">
                   <v-icon :color="ui.btnColor">
                     emoji_transportation
                   </v-icon>
                   {{props.item.stats.na1}}
                 </v-btn>
                 <v-btn icon @click="switchLocalRead()" v-if="!localRead && enableRegisterRead"
                 :disabled="true">
                   <v-icon :color="ui.btnColor">
                     text_snippet
                   </v-icon>
                 </v-btn>
                 <RegisterRead :listIndex="props.index"
                 v-if="enableRegisterRead && localRead"/>
                 <div :class="ui.textSubheadingBold"
                 v-if="props.item.basic.tag === 'A1'">
                   {{props.item.stats.na1}}
                 </div>
                 <div :class="ui.textSubheadingBold"
                 v-if="
                 props.item.basic.tag === 'O1' &&
                 props.item.basic.ver !== 'A'
                 ">
                   {{props.item.stats.nlike}}
                 </div>
               </v-layout>
             </td>
           </template>
         </v-data-table>
         <RegisterListBottom/>
         <v-layout class="mb-4"/>
         <v-layout class="mb-2"/>
       </v-flex>
      </v-layout>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import RegisterSelect from "@/data/register/components/RegisterSelect";
import RegisterRead from "@/data/register/components/RegisterRead";
import RegisterListHeading from "@/data/register/components/RegisterListHeading";
import RegisterListBottom from "@/data/register/components/RegisterListBottom";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";

export default {
  components: {
    RegisterRead,
    RegisterSelect,
    RegisterListHeading,
    RegisterListBottom
  },
  mixins: [dateFunctions, numberFunctions, apptheme, getList, displayFunctions],
  data() {
    return {
      maxRows: -1,
      btnSpinLoadMore: false,
      hideActions: true,
      barMovement: false,
      facilitySelect: false,
      localRead: false,
      enableProgressBar: true
    };
  },
  props: {
    date: {
      type: Object
    }
  },
  mounted() {
    setTimeout(() => {
      this.localRead = true;
    }, 500);
  },
  methods: {
    defineID(num) {
      return this.defineIDGShortLastSix(num);
    },
    switchLocalRead() {
      this.localRead = true;
    },
    defineTableContent(item) {
      let obj = {
        item0: "", // this is id
        item1: item.basic.id,
        item2: item.basic.title,
        item3: "",
        item4: "",
        item5: ""
      };
      // DEFINE ID
      obj.item0 = this.displayDocumentIDGTypeA(item.basic.tag, item.basic.idg);
      // DEFINE DATA SPECIFIC ITEMS
      if (item.basic.tag !== null && item.basic.ver === "A") {
        obj.item0 = item.basic.tag;
        obj.item1 = this.displayDocumentIDGTypeA(obj.item0, item.basic.idg);
        obj.item2 = item.basic.title;
        obj.item3 = item.char.dis;
        if (item.trans !== undefined && item.trans !== null) {
          obj.item4 = item.trans.flow[item.trans.flow.length - 1].title;
        }
        obj.item5 = this.dateTypeA(item.stats.dcrt);
      } else if (item.basic.tag === "A1") {
        obj.item1 = item.basic.id;
        obj.item2 = item.basic.title;
        obj.item3 = item.char.type;
        obj.item4 = item.char.dis;
        obj.item5 = item.char.obj;
      } else if (item.basic.tag === "F1") {
        obj.item3 = item.char.type;
        obj.item4 = item.char.theme;
        obj.item5 = item.stats.na1;
      } else if (item.basic.tag === "C1") {
        obj.item3 = item.char.area;
        obj.item4 = item.char.lcountry;
        obj.item5 = item.char.lstate;
      } else if (item.basic.tag === "O1") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.type;
        obj.item3 = item.char.dis;
        obj.item4 = item.char.org;
        obj.item5 = this.dateTimeAgo(item.stats.dcrt);
      } else if (item.basic.tag === "M2") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.driver;
        obj.item3 = item.char.type;
        obj.item4 = item.char.theme;
        obj.item5 = item.char.dis;
      } else if (item.basic.tag === "M5") {
        obj.item2 = item.basic.title;
        obj.item3 = item.char.type;
        obj.item4 = item.char.theme;
        obj.item5 = item.strategy.char.dis;
      } else if (item.basic.tag === "M7") {
        // obj.item1 = item.strategy.char.type;
        obj.item2 = item.char.type;
        obj.item3 = item.basic.title;
        obj.item4 = this.dateTypeA(item.stats.dcrt);
        obj.item5 = this.dateTypeA(item.stats.ddue);
      } else if (
        item.basic.tag === "W" ||
        item.basic.tag === "W1" ||
        item.basic.tag === "W2" ||
        this.tag === "B6.W"
      ) {
        obj.item1 = item.link.aid;
        obj.item2 = item.basic.title;
        obj.item3 = item.char.pri;
        obj.item4 = item.trans.flow[item.trans.flow.length - 1].title;
        obj.item5 = this.dateTypeA(item.stats.ddue);
      } else if (item.basic.tag === "W6") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.type;
        obj.item3 = item.char.dis;
        obj.item4 = item.char.cat;
        obj.item5 = item.char.crit;
      } else if (item.basic.tag === "E6") {
        obj.item1 = item.basic.title;
        obj.item1 = item.basic.title;
        obj.item2 = item.char.dis;
        obj.item3 = item.char.type;
        obj.item4 = item.char.cond;
        obj.item5 = item.char.crit;
      } else if (item.basic.tag === "E8") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.dis;
        obj.item3 = item.char.type;
        obj.item4 = item.link.epid;
        if (item.char.stat === true) {
          obj.item5 = "Verified";
        } else {
          obj.item5 = "Review";
        }
      } else if (item.basic.tag === "B1") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.dis;
        obj.item3 = item.char.theme;
        obj.item4 = item.char.rate;
        obj.item5 = item.trans.flow[item.trans.flow.length - 1].title;
      } else if (item.basic.tag === "B4") {
        obj.item1 = item.basic.title;
        obj.item2 = item.trans.flow[item.trans.flow.length - 1].title;
        obj.item3 = "$" + item.char.coste;
        obj.item4 = this.dateTypeA(item.stats.dstr);
        obj.item5 = this.dateTypeA(item.stats.dend);
      } else if (item.basic.tag === "B6") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.type;
        obj.item3 = item.trans.flow[item.trans.flow.length - 1].title;
        obj.item4 = this.dateTypeA(item.stats.dstr);
        obj.item5 = this.dateTypeA(item.stats.dend);
      } else if (item.basic.tag === "Q1") {
        obj.item1 = item.basic.title;
        obj.item2 = item.link.bid;
        obj.item3 = item.trans.flow[item.trans.flow.length - 1].title;
        obj.item4 = item.char.prio;
        obj.item5 = this.dateTypeA(item.stats.ddue);
      } else if (item.basic.tag === "B3" || item.basic.tag === "U1.B3") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.type;
        obj.item3 = item.trans.flow[item.trans.flow.length - 1].title;
        obj.item4 = item.char.pri;
        obj.item5 = this.dateTypeA(item.stats.ddue);
      } else if (item.basic.tag === "E2") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.dis;
        obj.item3 = item.char.pri;
        obj.item4 = item.trans.flow[item.trans.flow.length - 1].title;
        obj.item5 = this.dateTypeA(item.stats.ddue);
      } else if (item.basic.tag === "E1") {
        obj.item1 = item.basic.id;
        obj.item2 = item.basic.title;
        obj.item3 = item.char.type;
        obj.item4 = item.char.dis;
        obj.item5 = item.char.cat;
      } else if (item.basic.tag === "L1") {
        obj.item1 = item.basic.id;
        obj.item2 = item.basic.title;
        obj.item3 = item.char.dis;
        obj.item4 = item.char.make;
        obj.item5 = item.char.model;
      } else if (item.basic.tag === "L2") {
        obj.item1 = item.char.type;
        obj.item2 = item.basic.title;
        obj.item3 = this.dateTimeAgo(item.stats.dcrt);
      } else if (item.basic.tag === "S1") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.reach;
        obj.item3 = item.char.cond;
        obj.item4 = item.char.dis;
        obj.item5 = item.char.theme;
      } else if (item.basic.tag === "S6") {
        obj.item1 = item.basic.title;
        obj.item2 = item.char.found;
        obj.item3 = item.char.cat;
        obj.item4 = item.trans.flow[item.trans.flow.length - 1].title;
        obj.item5 = this.dateTypeA(item.stats.dcrt);
      } else {
        obj.item1 = "Undefined";
        obj.item2 = "Undefined";
        obj.item3 = "Undefined";
      }
      // RETURN OBJ
      return obj;
    }
  },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getSearchResultsCounter",
      "getPageTitle",
      "getRegisterInfo"
    ]),
    tag() {
      let tag = null;
      if (this.getSearchResults !== null) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    arch() {
      let arch = null;
      if (this.getSearchResults !== null) {
        arch = this.getSearchResults[0].basic.arch;
      }
      return arch;
    },
    enableRegisterSelect() {
      let logic = false;
      if (!this.enableRegisterRead) {
        logic = true;
      }
      return logic;
    },
    enableItemReachIcon() {
      let logic = null;
      if (this.tag === "S1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableOpsComplete() {
      let logic = null;
      if (this.tag === "O1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableItemAllocationIcon() {
      let logic = null;
      if (
        this.tag === "B1" ||
        this.tag === "B3" ||
        this.tag === "B6" ||
        this.tag === "E2" ||
        this.tag === "S6" ||
        this.tag === "W6"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableRoleNotAssignedIcon() {
      let logic = null;
      if (this.tag === "B3") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableRegisterRead() {
      let logic = false;
      // eslint-disable-next-line
      if (
        this.tag === "F1" &&
        this.getCurrentPage === "/registerlist" &&
        this.getRegisterInfo !== null &&
        this.getRegisterInfo !== undefined &&
        this.getRegisterInfo.tag !== "U1"
      ) {
        logic = true;
      } else if (
        this.tag === "A1" ||
        this.tag === "B1" ||
        this.tag === "U1.B3" ||
        this.tag === "B4" ||
        this.tag === "B6" ||
        this.tag === "B6.W1" ||
        this.tag === "Q1" ||
        this.tag === "B3" ||
        this.tag === "M2" ||
        this.tag === "M5" ||
        this.tag === "M7" ||
        this.tag === "O1" ||
        this.tag === "W1" ||
        this.tag === "W2" ||
        this.tag === "W6" ||
        this.tag === "E6" ||
        this.tag === "E8" ||
        this.tag === "E2" ||
        this.tag === "E1" ||
        this.tag === "L1" ||
        this.tag === "L2" ||
        this.tag === "S1" ||
        this.tag === "S6"
      ) {
        logic = true;
      }
      return logic;
    },
    headers() {
      let table = [
        { text: "ID", sortable: false },
        { text: "Tag", sortable: false },
        { text: "Name", sortable: false },
        { text: "Type", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        // { text: "Status", sortable: false, value: "name" },
        { text: "", sortable: false, align: "right" }
      ];
      if (this.tag !== null && this.arch === "A") {
        table[0].text = "Tag";
        table[1].text = "ID";
        table[2].text = "Title";
        table[3].text = "Dis.";
        table[4].text = "Process";
        table[5].text = "Created";
      } else if (this.tag === "F1") {
        table[2].text = "Facility";
        table[3].text = "Type";
        table[4].text = "Area";
        table[5].text = "Assets";
      } else if (this.tag === "A1") {
        table[1].text = "Tag";
        table[2].text = "Asset";
        table[3].text = "Type";
        table[4].text = "Discipline";
        table[5].text = "Function";
      } else if (this.tag === "C1") {
        table[1].text = "ABN";
        table[2].text = "Company";
        table[3].text = "Area";
        table[4].text = "Country";
        table[5].text = "State";
      } else if (this.tag === "O1") {
        table[1].text = "Notification";
        table[2].text = "Type";
        table[3].text = "Discipline";
        table[4].text = "Source";
        table[5].text = "Update";
      } else if (this.tag === "B1") {
        table[1].text = "Risk";
        table[2].text = "Discipline";
        table[3].text = "Theme";
        table[4].text = "Rating";
        table[5].text = "Process";
      } else if (this.tag === "B4") {
        table[1].text = "Budget";
        table[2].text = "Process";
        table[3].text = "Amount";
        table[4].text = "Start";
        table[5].text = "End";
      } else if (this.tag === "B6") {
        table[1].text = "Plan";
        table[2].text = "Type";
        table[3].text = "Process";
        table[4].text = "Start";
        table[5].text = "End";
      } else if (this.tag === "Q1") {
        table[1].text = "Order";
        table[2].text = "Budget";
        table[3].text = "Process";
        table[4].text = "Priority";
        table[5].text = "Due Date";
      } else if (this.tag === "B3" || this.tag === "U1.B3") {
        table[1].text = "Action";
        table[2].text = "Type";
        table[3].text = "Process";
        table[4].text = "Priority";
        table[5].text = "Due";
      } else if (
        this.tag === "W" ||
        this.tag === "W1" ||
        this.tag === "W2" ||
        this.tag === "B6.W1"
      ) {
        table[1].text = "Asset";
        table[2].text = "Work";
        table[3].text = "Priority";
        table[4].text = "Process";
        table[5].text = "Due Date";
      } else if (this.tag === "W6") {
        table[1].text = "Procedure";
        table[2].text = "Type";
        table[3].text = "Discipline";
        table[4].text = "Category";
        table[5].text = "Criticality";
      } else if (this.tag === "E6") {
        table[1].text = "Program";
        table[2].text = "Discipline";
        table[3].text = "Type";
        table[4].text = "Condition";
        table[5].text = "Quality";
      } else if (this.tag === "E8") {
        table[1].text = "Result";
        table[2].text = "Discipline";
        table[3].text = "Type";
        table[4].text = "Asset";
        table[5].text = "Status";
      } else if (this.tag === "M2") {
        table[1].text = "Strategy";
        table[2].text = "Driver";
        table[3].text = "Type";
        table[4].text = "Theme";
        table[5].text = "Discipline";
      } else if (this.tag === "M5") {
        table[1].text = "Series";
        table[2].text = "Plan";
        table[3].text = "Type";
        table[4].text = "Theme";
        table[5].text = "Discipline";
      } else if (this.tag === "M7") {
        table[1].text = "Tag";
        table[2].text = "Type";
        table[3].text = "Title";
        table[4].text = "Called";
        table[5].text = "Due Date";
      } else if (this.tag === "E1") {
        table[1].text = "Tag";
        table[2].text = "Equipment";
        table[3].text = "Type";
        table[4].text = "Discipline";
        table[5].text = "Category";
      } else if (this.tag === "E2") {
        table[1].text = "Study";
        table[2].text = "Discipline";
        table[3].text = "Priority";
        table[4].text = "Process";
        table[5].text = "Due Date";
      } else if (this.tag === "L1") {
        table[1].text = "Tag";
        table[2].text = "Material";
        table[3].text = "Discipline";
        table[4].text = "OEM";
        table[5].text = "Part";
      } else if (this.tag === "L2") {
        table[1].text = "Type";
        table[2].text = "Work";
        table[3].text = "Update";
      } else if (this.tag === "S1") {
        table[1].text = "Hazard";
        table[2].text = "Reach";
        table[3].text = "Condition";
        table[4].text = "Discipline";
        table[5].text = "Theme";
      } else if (this.tag === "S6") {
        table[1].text = "Incident";
        table[2].text = "State";
        table[3].text = "Type";
        table[4].text = "Process";
        table[5].text = "Event";
      } else {
        table[2].text = "Name";
      }
      return table;
    }
  }
};
</script>
